import cardTemplateUrl from 'emun.customer/customer-contacts.htm'
import tableTemplateUrl from 'emun.customer/customer-contacts-table.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import ServiceBus from 'servicestack/service-bus'
import ContactPopup from 'emun.customer/customer-contact.popover'
import ContactPrompt from 'emun.customer/contact-prompt'
import customerConfig from 'emun.customer/customer.config'
import $session from "servicestack/session";

class CustomerContactsController {
  constructor($rootScope) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.$on('contactSaved', () => $ctrl.contacts.load(true));
    $ctrl.$on('contactDeleted', () => $ctrl.contacts.load(true));
    $ctrl.bus = new ServiceBus();
    $ctrl.$session = $session;
    var url = 'QueryRetailerContactsJoin.json?';
    if (this.id || this.retailerId || this.customerId || this.customer) {
      url = 'QueryRetailerContacts.json?active=true&IncludeAllContacts=true&';
      url = url + 'retailerId=' + (this.id || this.retailerId || this.customerId || this.customer.id);
    }
    $ctrl.config = customerConfig;
    $ctrl.retailerId = this.id || this.retailerId || this.customerId || this.customer;
    if ($ctrl.retailerId && $ctrl.retailerId.toString().startsWith("CUST")) {
      $ctrl.config.hideAddContact = false;
      $ctrl.config.hideEditContact = false;
    }

    if (!this.customer && (this.id || this.retailerId || this.customerId )) {
      var retailerQuery = new AutoQuery({
        url: 'QueryRetailers.json?Id=' + (this.id || this.retailerId || this.customerId),
        orderBy: "CompanyName",
        autoLoad: true,
        onLoaded: args => {
          if (args.total === 0) {
            return alert("Could not find: " + (this.id || this.retailerId || this.customerId));
          }
          $ctrl.customer = args.first;
        }
      });
    }
    
    if (this.contactId) { url = url + "&Id=" + this.contactId }
    $ctrl.contacts = new AutoQuery({
      url: url,
      orderBy: 'Name',
      autoLoad: true,
      pageSize: 10
    })
  }
  deleteContact(contact) {
    const $ctrl = this;

    return modals.confirm("Are you sure?", "Delete Contact").result.then(function () {
      $ctrl.bus.send('DeleteContact.json', contact).then(function (response) {
        $ctrl.$emit('contactDeleted', $ctrl);
        $ctrl.contacts.load(true);
      });
    });
  }
  create() {
    const $ctrl = this;
    ContactPrompt.open({ model: { customer: $ctrl.customer } });
  }
  edit(contact) {
    const $ctrl = this;
    ContactPrompt.open({ model: { contact: contact } });
  }
  contactPopup(contact) {
    const $ctrl = this;
    //        ContactPrompt.open({ model: {customer: $ctrl.customer, contact: contact }});
    ContactPopup.open({ customer: $ctrl.customer ? $ctrl.customer : {}, contactId: contact.id });
  }
  contactPrompt(contact) {
    const $ctrl = this;
    //        ContactPrompt.open({ model: {customer: $ctrl.customer, contact: contact }});
    ContactPrompt.open({ model: {customer: $ctrl.customer, contact: contact}});
  }
}

let CustomerContacts = {
  bindings: {
    id: '@',
    customerId: '@',
    retailerId: '@',
    customer: '<',
    contactId: '@'
  },
  controller: CustomerContactsController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || ($attrs.table ? tableTemplateUrl : cardTemplateUrl)
  }
}

export default CustomerContacts